import Box from '@mui/material/Box'
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from 'components/Sidebar/Sidebar'
import { useMediaQuery, useTheme } from '@mui/material'
import { Alert } from 'components/Alert/Alert'

const Layout = () => {
  const { pathname } = useLocation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const hideSidebar =
    pathname !== '/place' &&
    pathname !== '/order' &&
    pathname !== '/product' &&
    pathname !== '/route' &&
    pathname !== '/' &&
    isMobile
  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {!hideSidebar && <Sidebar />}
      <Alert />
      <Box
        component='main'
        sx={{
          position: 'relative',
          flex: '1 1 auto',
        }}>
        <Outlet />
      </Box>
    </Box>
  )
}

export default Layout
